import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';

function S3ExcelPreview({ s3Url }: {s3Url: string}) {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    const fetchAndParseExcel = async () => {
      try {
        const response = await fetch(s3Url);
        const arrayBuffer = await response.arrayBuffer();

        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // array of arrays

        setData(jsonData);
      } catch (error) {
        console.error('Error loading XLSX from S3:', error);
      }
    };

    fetchAndParseExcel();
  }, [s3Url]);

  return (
    <div className='overflow-auto w-full h-40'>
      {data.length > 0 ? (
        <table border={1}>
          <tbody>
            {data.map((row: any, i: number) => (
              <tr key={i}>
                {row.map((cell: any, j: number) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Loading or no data found...</p>
      )}
    </div>
  );
}

export default S3ExcelPreview;
